
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import PSubtitle from '@/components/config/PSubtitle.vue'

@Component({
  components: { PSubtitle },
})
  export default class StatusPreview extends Vue {
    @Prop({ type: String, default: 'top-left' }) position!: string
    @Prop({ type: String, default: 'ribbon' }) selectedTemplate!: string
    @Prop({ type: String, default: '#6185DB' }) ribbonColor!: string
    @Prop({ type: String, default: null }) template!: string

    get chipPosition () {
      const positions = {
        'top-left': 'chip-top-left',
        'top-right': 'chip-top-right',
        'bottom-left': 'chip-bottom-left',
        'bottom-right': 'chip-bottom-right',
      }
      return positions[this.position] || 'chip-top-left'
    }

    // Posiciones especiales para banner y sidebar
    get bannerPosition () {
      const pos = this.position
      return pos.includes('top') ? 'banner-top' : 'banner-bottom'
    }

    get sideBarPosition () {
      const pos = this.position
      return pos.includes('left') ? 'side-bar-left' : 'side-bar-right'
    }

    // Gradiente para el overlay con degradado
    get gradientStyle () {
      const color = this.ribbonColor
      const pos = this.position

      if (pos.includes('top')) {
        return {
          background: `linear-gradient(to bottom, ${this.hexToRgba(color, 0.9)} 0%, transparent 100%)`,
        }
      } else {
        return {
          background: `linear-gradient(to top, ${this.hexToRgba(color, 0.9)} 0%, transparent 100%)`,
        }
      }
    }

    // Valores para progress bar
    get progressValue () {
      return 50 // valor por defecto
    }

    // Función para convertir color hex a rgba para transparencias
    hexToRgba (hex: string, alpha = 1) {
      if (!hex) return `rgba(0, 0, 0, ${alpha})`

      // Si es un color de Vuetify como "primary"
      if (!hex.startsWith('#')) return hex

      const r = parseInt(hex.slice(1, 3), 16)
      const g = parseInt(hex.slice(3, 5), 16)
      const b = parseInt(hex.slice(5, 7), 16)

      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
